import { c as _c } from "react/compiler-runtime";
import { useCreditCardCompareOfferContext } from '../OfferContext';
import { BonusOfferContainer } from './BonusOffer.container';
import { ContentText } from './components/ContentText';
export function BonusOffer() {
  const $ = _c(2);
  const {
    offer: t0
  } = useCreditCardCompareOfferContext();
  const {
    signUpBonusDetails
  } = t0;
  let t1;
  if ($[0] !== signUpBonusDetails) {
    t1 = <BonusOfferContainer><ContentText>{signUpBonusDetails}</ContentText></BonusOfferContainer>;
    $[0] = signUpBonusDetails;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}